.selectChatDialog {
  height: 100%;
}

.selectChatDialogBody {
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  overflow: hidden;
}

.searchRow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  justify-content: space-between;
  padding-inline-end: 20px;
}
.searchRow.withAccountSwitch :global(.select-chat-account-input) {
  flex: 1;
}

.header {
  word-break: break-all;
}

.switchAccountButton {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 0;
  background: transparent;
  color: var(--textPrimary);
  cursor: pointer;
}

.switchAccountText {
  line-height: 1;
  font-size: 16px;
}

.switchAccountContainer {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}